export default __webpack_public_path__ + "static/divider2MobSvg-2dd46749feac53d59ea73999b0df0c8c.svg";